import React from 'react';
import { useAppStore } from "../../../../../GlobalStore/GlobalStore.ts";
import SubscriptionStatus from './SubscriptionStatus';
import ManageSubscriptionButton from './ManageSubscriptionButton';
import DeleteAccountButton from './DeleteAccountButton';
import SessionUsage from './SessionUsage/SessionUsage';
import RestorePurchasesButton from './RestorePurchasesButton';
import UsageBasedToggle from './UsageBasedToggle';
import SubscribeNowButton from './SubscribeNowButton';
import RemainingBalance from './RemainingBalance';
import {isMobileApp} from "../../../../../Utils/misc/envNameUtils.ts";

const ManageAccount: React.FC = () => {
  const userObj = useAppStore((state: any) => state.userObj);
  const environmentObj = useAppStore((state: any) => state.environmentObj);
  const dynamicStateObj = useAppStore((state: any) => state.dynamicStateObj);
  const updateSessionUsage = useAppStore((state: any) => state.updateSessionUsage);

  const { environment } = environmentObj;
  const { subscriptionPlan, remainingBalance } = userObj;
  const { sessionUsage } = dynamicStateObj;
  const handleReset = () => {
    updateSessionUsage(null, "clear");
  };

  return (
    <div>
      <div className="bg-neutral-300 dark:bg-neutral-800 p-6 rounded-lg shadow-lg space-y-6 flex flex-col">
        <SubscriptionStatus subscriptionPlan={subscriptionPlan} />
        <RemainingBalance remainingBalance={remainingBalance} subscriptionPlan={subscriptionPlan} />
        {subscriptionPlan && <UsageBasedToggle />}
        {subscriptionPlan ? <ManageSubscriptionButton /> : <SubscribeNowButton />}
        {isMobileApp(environment) && subscriptionPlan !== "hybrid" && subscriptionPlan !== "internal" && (
          <RestorePurchasesButton />
        )}

        {(subscriptionPlan === 'hybrid' || subscriptionPlan === 'internal') && (
          <SessionUsage
            sessionUsage={sessionUsage}
            onReset={handleReset}
          />
        )}
        <DeleteAccountButton />
      </div>
    </div>
  );
};

export default ManageAccount;